import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-beneficiary-type-modal',
	styles: [
		`
			.card {
				width: 300px;
				height: 230px;
				border: 1px solid #d9d9d9;
				box-sizing: border-box;
			}
			.bold-border {
				border: 2px solid #3f55e3;
			}
			.gray {
				color: #626262;
			}
			@media only screen and (max-width: 768px) {
				.card {
					width: 45%;
					height: 120px;
				}
				.card-label {
					margin-top: 16px;
					font-size: 16px;
				}
				img {
					max-height: 72px;
				}
			}
		`,
	],
	templateUrl: './beneficiary-type-modal.component.html',
})
export class BeneficiaryTypeModalComponent {
	selected = 0;

	constructor(
		public dialogRef: MatDialogRef<BeneficiaryTypeModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {}

	closeModal() {
		this.dialogRef.close(0);
	}

	onContinue(): void {
		this.dialogRef.close(this.selected);
	}
}
